<div class="bd-populations-container" data-id="populations-container">
  <bd-populations-overview
    [populations]="(populations$ | async) ?? []"
    [isLoading]="isLoading$ | async"
    (loadMorePopulations)="loadNextPage()"
    (searchPopulations)="searchPopulations($event)"
    (openDeletePopulation)="onOpenDeletePopulation($event)"
    (newPopulationCreated)="navigateToSearch()"
    (addPopulationToFrame)="onOpenPopulationInFrame($event)"
    (editDataForObjectsInPopulation)="onEditDataForObjectsInPopulation($event)"
  ></bd-populations-overview>
  <bd-content-open-container
    [visible]="addPopulationToFrameModalVisible"
    (visibleChange)="onOpenPopulationInFrameModalVisibleChange($event)"
    [elementCollection]="population$ | async"
    [numberOfCollectionElements]="numberOfPopulationElements ?? 0"
    [numberOfCollectionElementsLoading]="populationLoading"
    [elementCollectionLoading]="populationLoading"
  />
  <bd-delete-population-modal
    [visible]="deletePopulationModalVisible"
    [population]="populationToBeDeleted"
    [usedInFrames]="(usedInFrames$ | async) ?? []"
    [loading]="framesLoading$ | async"
    (deletePopulation)="onDeletePopulation($event)"
    (visibleChange)="onVisibleChange($event)"
  ></bd-delete-population-modal>
</div>
